// Placeholder de imagen generado localmente (data URI, sin red) para productos
// o logos sin imagen propia. Antes esto pegaba contra placehold.co en cada
// carga de la tienda -- si ese servicio externo cae o se bloquea, la imagen
// rota de cada producto sin foto rompía visualmente toda la tienda.
function escapeXml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" }[c]));
}

export function placeholderImage(label, color = "#DC2626") {
  const text = escapeXml((label || "").trim().split(" ")[0] || "MQ");
  const bg = /^#[0-9a-fA-F]{3,8}$/.test(color) ? color : "#DC2626";
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400">`
    + `<rect width="400" height="400" fill="${bg}"/>`
    + `<text x="200" y="208" font-family="system-ui, -apple-system, Segoe UI, Roboto, sans-serif" `
    + `font-size="72" font-weight="700" fill="#FFFFFF" text-anchor="middle" dominant-baseline="middle">${text}</text>`
    + `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
